import {
  apiClient,
  handleResponse,
} from './axios';

async function isExamFinished(body) {
  try {
    const response = await apiClient.post('/examtype1/exam', body);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getQuizResultsByGroup(groupId, semester, examId) {
  try {
    const response = await apiClient.get(`/group/quiz/${groupId}/${semester}/${examId}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    Promise.reject(error.response.data.message);
    return error;
  }
}

async function getTestById(testId) {
  try {
    const response = await apiClient.get(`/examtype1/${testId}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getQuestionPool(poolId) {
  try {
    const response = await apiClient.get(`/qpool/questions/${poolId}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getAllStudentsWithQuiz() {
  try {
    const response = await apiClient.get('/examtype1/students');
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function updateQuizData(testId, body) {
  try {
    const response = await apiClient.put(`/examtype1/data/${testId}`, body);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

const examType1Services = {
  isExamFinished,
  getQuestionPool,
  getQuizResultsByGroup,
  getTestById,
  getAllStudentsWithQuiz,
  updateQuizData,
};

export default examType1Services;
